import { Typography } from "@mui/joy";
import { TabView, TabPanel } from "primereact/tabview";

import { AppointmentsPanel } from "./Panels/Appointments";
import { EmployeesPanel } from "./Panels/Employees";

function SiteSetup() {
  return (
    <div>
      <Typography level="h2" component="h1">
        Site Setup
      </Typography>
      <TabView>
        <TabPanel header={"Employees"}>
          <EmployeesPanel />
        </TabPanel>
        <TabPanel header="Appointments">
          <AppointmentsPanel />
        </TabPanel>
      </TabView>
    </div>
  );
}

export default SiteSetup;
